export default __webpack_public_path__ + "static/media/progressReport.6864ff1b.svg";